import React, { Component } from 'react';
import style from './index.module.css';

class Chapter2 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { status, firstChargeTime, firstChargeStation } = this.props.data;
    // if (status === 0) return;

    return (
      <div
        className={style.pageBgType2}
        style={{
          height: document.documentElement.clientHeight
        }}
      >
        <div
          style={{
            height: document.documentElement.clientHeight - 50,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingRight: 0,
            paddingLeft: 0,
            paddingTop: 0
          }}
        >
          <div className={style.chapter2Icon} />
          {status === 1 && (
            <div className={style.itemBox}>
              {/* <div className={style.xpIconBox} /> */}
              <p className={style.ordinaryText}>
                <span className={style.blueBigText}>您的充电之旅</span>
                <span className={style.blueBigText}>尚未开启</span>
                <br />
                <span className={style.grayNormalText}>
                  期待与你的第一次相遇
                </span>
              </p>
            </div>
          )}
          {status === 2 && (
            <div className={style.itemBox}>
              {/* <div className={style.xpIconBox} /> */}
              <p className={style.ordinaryText}>
                <span className={style.blueNormalText}>{firstChargeTime}</span>
                <br />
                你第一次充电
                <br />
                <span className={style.blueBigText}>{firstChargeStation}</span>
                <br />
                <p className={style.grayNormalText}>
                  陪你开启这趟电力满满的奇妙之旅
                </p>
              </p>
            </div>
          )}
          {status === 3 && (
            <div className={style.itemBox}>
              {/* <div className={style.xpIconBox} /> */}
              <p className={style.ordinaryText}>
                <span className={style.blueNormalText}>{firstChargeTime}</span>
                <br />
                你第一次充电，是否不知所措？
                <br />
                <span className={style.blueBigText}>{firstChargeStation}</span>
                <br />
                <p className={style.grayNormalText}>
                  陪你开启这趟电力满满的奇妙之旅
                </p>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Chapter2;
